import { INPUT_VALUE_CHANGE } from '../../Constants/AppConstants';
import { IActionPayloaded } from '../../Infrastructure/Action/IAction';
import { BaseInputActions } from '../Shared/BaseInputActions';
import { INumberValueChangedPayload } from './Payloads';
import { injectable } from 'inversify';

@injectable()
export class VolmaNumberActions extends BaseInputActions{

    public ChangeValue(name: string, value: number): IActionPayloaded<INumberValueChangedPayload> {
        return { type: INPUT_VALUE_CHANGE, Payload: { InputName: name, Value: value} };
    }
}
